module.exports = __webpack_public_path__ + "static/img/5152_phase_function_Paper_Points.4a61212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5152_phase_function_Paper_Points.png
// module id = MlcS
// module chunks = 0